// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"21b5b917","361":"d098db26","511":"8f9fb2d6","767":"0d98821d"}[chunkId] + ".chunk.js";
};